import useragent from '@finance/useragent'
import { APP, SIDE, RUN_SIDE } from '@common/loan-act/env'
import { BuryToolOptions, BuryParams } from '$utils/collect'
import * as positions from './config'
import { ACT_CODE } from '$utils/act-config'
// positions 使用埋点构建页面生成
// 参考 index.d.ts 中的 BuryToolOptions

let clientId = '04'
if (useragent.isSuishouji) {
  clientId = '04'
} else if (useragent.isSuiguanjia) {
  clientId = '01'
} else if (useragent.isWindows) {
  clientId = '02'
} else {
  clientId = '12'
}

const config: BuryToolOptions = {
  positions,
  transferApp: {
    kn: APP.kn,
    ssj: APP.ssj,
  },
  transferSide: {
    app: SIDE.app,
    h5: SIDE.h5
  },
  knStaticParams: {
    yyhd_id: ACT_CODE,
  }, // 卡牛上报工具的一些静态公共参数
  ssjStaticParams: {
    ext_type: ACT_CODE,
    ext_value: '旅游账本分享活动',
    business_type: 'selflabel',
    source_id: RUN_SIDE === SIDE.app ? 'ssj' : 'h5',
    sku: 'lvyouzhangben',
    client_id: clientId,
    suid: '',
    book_market_id: '',
    book_id: '',
    ssjid: ''
  }, // 随手记上报工具的一些静态公共参数
  knTransferDataBFS: (posData: BuryParams) => posData, // 用来添加一些公共动态参数
  ssjTransferDataBFS: null,
}

export default config
